<div mat-dialog-title class="ds">
  <span>{{ appStrings.customTool_dialogTitle }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon id="closeButton" class="close-icon">close</mat-icon>
  </button>
</div>
<div id="formContainer" mat-dialog-content class="content ds" [ngClass]="{'mobile': isMobile}">
  <form [formGroup]="toolForm">
    <div id="searchFormContent" class="tool-container">
      <ds-textfield id="listPrice" class="fill-width" [label]="appStrings.customTool_listPriceLabel" label_orientation="vertical-label" 
        [control]="toolForm.controls.listPrice" start_adornment_type="text" [start_adornment_value_text]="currencySymbol"
        appNumericInput [allowDecimals]="true" [maxDigits]="8">
      </ds-textfield>
      <div class="multiline-container">
        <ds-multiline id="description" class="fill-width" [label]="appStrings.customTool_descriptionLabel" label_orientation="vertical-label" 
          [control]="toolForm.controls.description" (onBlur)="trimDescriptionControl($event.target.value)">
        </ds-multiline>
      </div>
      <ds-textfield id="unitNetPrice" class="half-width" [label]="appStrings.customTool_unitNetPriceLabel" label_orientation="vertical-label" 
        [control]="toolForm.controls.unitNetPrice" start_adornment_type="text" [start_adornment_value_text]="currencySymbol"
        appNumericInput [allowDecimals]="true" [maxDigits]="8">
      </ds-textfield>
      <ds-textfield id="weight" class="half-width" [label]="appStrings.customTool_weightLabel" label_orientation="vertical-label" 
        [control]="toolForm.controls.weight" end_adornment_type="text" [end_adornment_value_text]="weightSymbol"
        appNumericInput [allowDecimals]="true" [maxDigits]="8">
      </ds-textfield>
      <ds-select id="countryOfOrigin" class="fill-width" [label]="appStrings.customTool_countryOfOriginLabel" [dropOptions]="mobileCountryList"  
        label_orientation="vertical-label" [control]="toolForm.controls.countryOfOrigin">
      </ds-select>
    </div>
  </form>
</div>
<div id="dialog-actions" mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button id="closeButton" variant="label-only" size="medium" type="secondary" (onClick)="close(0)"
      [label]="appStrings.button_close">
    </ds-button>
    <ds-button id="addButton" variant="label-only" size="medium" type="primary" (onClick)="saveInfo(productInfo)" 
      [label]="appStrings.button_add" [isDisabled]="!toolForm.valid">
    </ds-button>
  </div>
</div>